import React, { useEffect } from 'react'
import './style.css'
import {
  CardHeader,
  CardBody,
  Button,
  Card,
  ListGroupItem,
  ListGroup,
  Row,
  Spinner,
} from 'reactstrap'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMessages } from 'store/commboard/actions'
import { toggleEditMessage } from 'store/commboard/actions'
import { onDelete } from 'store/commboard/actions'
import { toggleMessage } from 'store/commboard/actions'
import { toggle } from 'store/commboard/actions'
// TextEditorModal is mounted once globally in layouts/Admin.js so the
// "view message" modal can be opened from any page (e.g. from a
// notification), not only while this widget is on the dashboard.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Avatar from 'assets/img/anonymous-avatar.jpg'
import EditDeleteButtonsContainer from 'components/Custom/EditDeleteButtonsContainer'
import Loader from 'views/pages/Loader'
import { useMessages } from '../../Admin/useMessages'

const MAX_CHARACTERS = 50
const displayText = (message) => {
  return (
    message.data.message
      .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces with regular spaces
      .replace(/(<([^>]+)>)/gi, '') // Remove HTML tags from the text
      .substring(0, MAX_CHARACTERS) + // Truncate the text to the maximum number of characters
    (message.data.message.length > MAX_CHARACTERS ? '...' : '')
  )
}

const Commboard = () => {
  const dispatch = useDispatch()
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  // const commboard = useSelector((state) => state.commboard)
  // const messages = useSelector((state) => state.commboard.messages)
  // const user = useSelector((state) => state.auth.user)

  // // const removeNonBreakingSpaces = (text) => {
  // // 	return text.replace(/&nbsp;/g, ' ')
  // // }
  // /*eslint-disable */

  // useEffect(() => {
  // 	dispatch(fetchMessages())
  // }, [])
  // Fetching messages
  const { messages, user, commboard } = useMessages()

  return (
    <Card className='position-relative h-100'>
      <CardHeader className='pt-3 commboard-header'>
        <Row className='align-items-center'>
          <div className='col'>
            <h5 className='h3 mb-0'>
              {language.general ? language.general.communitacion_board : null}
            </h5>
          </div>
          {user.access === 1 && (
            <div className='d-flex'>
              <Button
                className='px-3 py-1 mr-2'
                color='info'
                type='button'
                size='sm'
                onClick={() => dispatch(toggle())}
                style={{ backgroundColor: '#01A0F2' }}
              >
                <span className='btn-inner--icon'>
                  <FontAwesomeIcon icon={faPlus} style={{ fontSize: '16px' }} />
                  {/* <i className='ni ni-fat-add' style={{ fontSize: '18px' }} /> */}
                </span>
              </Button>
            </div>
          )}
        </Row>
      </CardHeader>
      <CardBody
        className={`commboard-body p-0 ${
          messages.length > 2 ? 'scrollbar' : 'overflow-hidden'
        }`}
      >
        {commboard.loading ? (
          <div className='d-flex justify-content-center align-items-center mt-6'>
            <Loader color='primary' />
          </div>
        ) : (
          <ListGroup data-toggle='checklist' flush>
            {messages.length > 0 ? (
              messages.map((message, index) => (
                <ListGroupItem
                  key={index}
                  className='list-group-item-action flex-column align-items-start py-4 px-4 admin-list'
                  tag='a'
                  onClick={() => dispatch(toggleMessage(message.data.message))}
                  style={{ cursor: 'pointer' }}
                >
                  <div className='d-flex w-100 justify-content-between'>
                    <div>
                      <div className='d-flex w-100 align-items-center'>
                        <img
                          alt='...'
                          className='avatar avatar-sm mr-2'
                          style={{ objectFit: 'contain' }}
                          src={
                            message.avatar
                              ? JSON.parse(message.avatar).url
                              : Avatar
                          }
                        />
                        <h5 className='mb-1'>
                          {message && message.created_by}
                        </h5>
                      </div>
                    </div>
                    <div>
                      {user.access === 1 && (
                        <div className='d-flex mt-auto'>
                          <Button
                            color='light'
                            className='btn-icon-only '
                            size='sm'
                            outline
                            onClick={(e) => {
                              e.stopPropagation()
                              dispatch(
                                toggleEditMessage(
                                  message.id,
                                  message.data.message,
                                  moment(message.expiration_date)
                                )
                              )
                            }}
                          >
                            <i className='fas fa-edit' />
                          </Button>
                          <Button
                            color='danger'
                            className='btn-icon-only'
                            size='sm'
                            outline
                            onClick={(e) => {
                              e.stopPropagation()
                              /* eslint-disable */
                              if (confirm('Are you sure you want to delete')) {
                                dispatch(onDelete(message.id))
                              }
                            }}
                          >
                            <i className='fas fa-trash'></i>
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div style={{ cursor: 'pointer' }}>
                      <div className='mb-0 pt-2'>
                        <p className='mb-0'>{displayText(message)}</p>
                      </div>
                    </div>
                  </div>
                </ListGroupItem>
              ))
            ) : (
              <div
                className='d-flex justify-content-center align-items-center'
                style={{ minHeight: '300px' }}
              >
                <h3 className='p-4'>No shared messages</h3>
              </div>
            )}
          </ListGroup>
        )}
      </CardBody>
    </Card>
  )
}
export default Commboard
